var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsEnlarged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.14286C10.4571 2.14286 12.8571 4.54286 12.8571 7.5C12.8571 10.4571 10.4571 12.8571 7.5 12.8571C4.54286 12.8571 2.14286 10.4571 2.14286 7.5C2.14286 4.54286 4.54286 2.14286 7.5 2.14286ZM7.5 0C3.35357 0 0 3.35357 0 7.5C0 11.6464 3.35357 15 7.5 15C11.6464 15 15 11.6464 15 7.5C15 3.35357 11.6464 0 7.5 0Z",
    fill: "#FF7E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7141 6.71765H8.24979V4.2855C8.24979 3.84622 7.8855 3.48193 7.44622 3.48193C7.00693 3.48193 6.64265 3.84622 6.64265 4.2855V6.71765H4.2855C3.84622 6.71765 3.48193 7.08193 3.48193 7.52122C3.48193 7.9605 3.84622 8.32479 4.2855 8.32479H6.64265V10.7141C6.64265 11.1534 7.00693 11.5176 7.44622 11.5176C7.8855 11.5176 8.24979 11.1534 8.24979 10.7141V8.32479H10.7141C11.1534 8.32479 11.5176 7.9605 11.5176 7.52122C11.5176 7.08193 11.1534 6.71765 10.7141 6.71765Z",
    fill: "#FF7E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsEnlarged);
export default __webpack_public_path__ + "static/media/is_enlarged.0ef10ba82419564545106b3913ceb01c.svg";
export { ForwardRef as ReactComponent };